import Rest from '@services/Rest';

/**
 * @typedef {adjustSaleAmounts}
 */
export default class adjustSaleAmounts extends Rest {
  /**
   * @type {String}
   */
  static resource = '/admin/adjust-sale-amounts'
}
